import { AutoComplete, Button, Input, Modal, Select, Tag, Tooltip } from "antd";
import { useState } from "react";
import {
  classification_select,
  state_select,
} from "Benchmarking/Config/SelectData";
import "Benchmarking/Scss/SearchAdvanceFaculty.scss";
import { getInstitutionSuggestSearch } from "Benchmarking/Services/Institution";

const SearchAdvanceInstitution = ({ filters, setFilters }) => {
  const [tempFilters, setTempFilters] = useState({});
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [currentSearchQueryValue, setCurrentSearchQueryValue] = useState("");
  const [openAdd, setOpenAdd] = useState(false);

  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          height: "28px",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const handleInputChangeFaculty = (value) => {
    if (value) {
      getInstitutionSuggestSearch(value, (res) => {
        setFacultyOptions(
          res.map((item) => {
            return {
              ...item,
              value: item.name,
            };
          })
        );
      });
      setCurrentSearchQueryValue(value);
    } else {
      setFilters({ ...filters, query: null });
      setCurrentSearchQueryValue("");
    }
  };

  const handleInputConfirmFaculty = (value, option) => {
    setFilters({
      ...filters,
      query: `${option.name}`,
    });
  };
  const onChangeState = (value) => {
    setTempFilters({
      ...tempFilters,
      states: value,
    });
  };
  const onChangeClassification = (value) => {
    setTempFilters({
      ...tempFilters,
      classifications: value,
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const handleApplyFilters = () => {
    setOpenAdd(false);
    setFilters({
      ...filters,
      ...tempFilters,
    });
  };

  const tagRender = (label, closable, onClose) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  return (
    <div className="search-advanced-faculty">
      <Modal
        title={<p className="title-search-advance">Advanced Search</p>}
        open={openAdd}
        onCancel={() => setOpenAdd(false)}
        width={650}
        centered={true}
        footer={[
          <Button key="back" onClick={() => setOpenAdd(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleApplyFilters}>
            Apply
          </Button>,
        ]}
      >
        <div className="affilication">
          <Select
            className="filter-item"
            showSearch
            placeholder="State"
            optionFilterProp="children"
            mode="multiple"
            allowClear
            tagRender={tagRenderForSelect}
            onChange={onChangeState}
            filterOption={filterOption}
            options={state_select}
            style={{ width: "100%", marginBottom: "15px", height: "40px" }}
          />
          <Select
            mode="multiple"
            allowClear
            className="filter-item"
            showSearch
            tagRender={tagRenderForSelect}
            placeholder="Classification"
            optionFilterProp="children"
            onChange={onChangeClassification}
            filterOption={filterOption}
            options={classification_select}
            style={{ width: "100%", marginBottom: "15px", height: "40px" }}
          />
        </div>
      </Modal>
      <div className="search-section">
        <div className="search-bar">
          <AutoComplete
            options={facultyOptions}
            placeholder="Enter to search"
            onChange={handleInputChangeFaculty}
            onSelect={handleInputConfirmFaculty}
            style={{ width: "100%" }}
          >
            <Input
              style={{ height: "40px" }}
              onPressEnter={() => {
                setFilters({ ...filters, query: currentSearchQueryValue });
              }}
            />
          </AutoComplete>
        </div>
        <div
          className="advanced-search-button"
          onClick={() => setOpenAdd(true)}
        >
          <p>Advanced Search</p>
        </div>
      </div>
      <div className="filters-search-modal">
        {filters.states && (
          <div className="group-filters">
            <p>State: </p>
            {filters.states.map((item) => tagRender(item, null, null))}
          </div>
        )}
        {filters.classifications && (
          <div className="group-filters">
            <p>Classification: </p>
            {filters.classifications.map((item) => tagRender(item, null, null))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAdvanceInstitution;
